import posthog from "posthog-js";
import type { PostHogConfig } from "posthog-js";

export const POSTHOG_KEY = "phc_kmn3g5wULdYQ5vXxG4ihaLkeXxpe9UgKMGL4SUtB4TJP";
export const POSTHOG_HOST = "https://eu.i.posthog.com";
export const POSTHOG_PROJECT_ID = "258552";

export const BRAND = "immovox";

/**
 * PostHog EU Cloud en mesure d'audience cookieless.
 * Aucun cookie/localStorage PostHog, pas d'autocapture ni de session replay.
 * Les pageviews et événements métier restent capturés dès le premier hit.
 */
export const posthogOptions: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  cookieless_mode: "always",
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: false,
  disable_session_recording: true,
  loaded: (ph) => {
    ph.register({ brand: BRAND });
  },
};

type IdentifyPayload = {
  userId: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  isAdmin?: boolean | null;
  agencyId?: string | null;
  agencyName?: string | null;
  plan?: string | null;
  subscriptionStatus?: string | null;
};

/** Identifie l'utilisateur connecté et l'associe à son agence (group analytics). */
export const identifyUser = ({
  userId,
  email,
  firstName,
  lastName,
  isAdmin,
  agencyId,
  agencyName,
  plan,
  subscriptionStatus,
}: IdentifyPayload) => {
  try {
    posthog.identify(userId, {
      email: email ?? undefined,
      first_name: firstName ?? undefined,
      last_name: lastName ?? undefined,
      is_agency_admin: isAdmin ?? undefined,
      agency_id: agencyId ?? undefined,
      plan: plan ?? undefined,
      subscription_status: subscriptionStatus ?? undefined,
      brand: BRAND,
    });

    if (agencyId) {
      posthog.group("agency", agencyId, {
        name: agencyName ?? undefined,
        plan: plan ?? undefined,
        subscription_status: subscriptionStatus ?? undefined,
        brand: BRAND,
      });
    }
  } catch {
    /* noop */
  }
};

/** Réinitialise l'identité PostHog (déconnexion). */
export const resetUser = () => {
  try {
    posthog.reset();
  } catch {
    /* noop */
  }
};
